import Vue from 'vue'
import VueRouter from 'vue-router'

// 进度条
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

//无需验证的路由
import noAuth from './moudles/noAuth.js';


import store from '@/store';

// 路由数据
import routes from './routes'

// fix vue-router NavigationDuplicated
const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return VueRouterPush.call(this, location).catch(err => err)
}
const VueRouterReplace = VueRouter.prototype.replace
VueRouter.prototype.replace = function replace (location) {
  return VueRouterReplace.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

// 导出路由 在 main.js 里使用
const router = new VueRouter({
  linkActiveClass: 'active',
  //mode: 'history',
  mode: 'hash',
  //base: process.env.BASE_URL,
  routes
})

router.addRoutes(noAuth);

// 全局路由守卫
router.beforeEach((to, from, next) => {
  
  console.log("beforeEach");
  console.log(this);
  if (to.meta.clearCache!=undefined) {
    to.meta.clearCache=false;
  } 
  next();
})

//无需验证的
function exportWhiteListFromRouter(router){
  let res = []
  for(let item of router)
    res.push(item.path)
  return res
};

// 路由白名单 - 无需验证登录的页面
const whiteList = exportWhiteListFromRouter(noAuth);

/**
 * 路由拦截
 * 权限验证
 */
router.beforeEach(async (to, from, next) => {
  if(whiteList.indexOf(to.path) != -1){
    next();
    return;
  }

  let isLogin = store.state.account.isLogin;

  //用户所有可以访问的路由
  let userPool = store.state.account.userMenuList;


  //console.log(userPool,to,'=====');

  // 确认已经加载多标签页数据 https://github.com/d2-projects/d2-admin/issues/201
  //await store.dispatch('d2admin/page/isLoaded')
  // 确认已经加载组件尺寸设置 https://github.com/d2-projects/d2-admin/issues/198
  //await store.dispatch('d2admin/size/isLoaded')

  // 进度条
  NProgress.start();
  // 关闭搜索面板
  //store.commit('d2admin/search/set', false)
  // 验证当前路由所有的匹配中是否需要有登录验证的
  if (to.matched.some(r => r.meta.auth)) {
    /* let issetAuth = userPool.findIndex((item)=>item.resourceCode === to.name);
    if(issetAuth === -1){
      next({
        path:"/noauth",
      });
     // console.log('没有权限');;
      return;
    } */

    if(isLogin){
      next();
    }else{
      next({// 校验失败，跳转至登录界面
      path: '/login',
        query: {
          redirect: to.fullPath
        }
      });
    }
    NProgress.done();

  } else {
    // 不需要身份校验 直接通过
    next()
  }
})

router.afterEach(to => {
  // 进度条
  NProgress.done();
  // 多页控制 打开新的页面
  //store.dispatch('d2admin/page/open', to)
  // 更改标题
  if(to.meta.title) document.title = to.meta.title;
});

export default router
